import { getSmsClient } from '@/services/sms'

class AES {
  async encrypt(value) {
    const response = await getSmsClient().post('/resource/encrypt', { value })
    return response.data.value
  }

  async decrypt(value) {
    const response = await getSmsClient().post('/resource/decrypt', { value })
    return response.data.value
  }
}

export default new AES()
